export default __webpack_public_path__ + "static/media/icon-chevron-left.1edb66d9.svg";